import React, { Component } from 'react';

import {
    mdiCloudDownloadOutline  
}                           from '@mdi/js';

import Icon                 from '@mdi/react';

import './State.css';


class LoadingState extends Component {

    render() {

        const { label } = this.props;

        return (
            <div className="state-container">
                
                <div className="state-content">
                    <Icon path={mdiCloudDownloadOutline} size={'6rem'} color="#CCC" />
                    <div className="state-text">
                        <div>{ label }</div>
                    </div>
                </div>

            </div>
        );
    }
}

LoadingState.defaultProps = {
    label: ''
}

export default LoadingState;
